import controller from './oo-admin-kjson.controller';
import template from './oo-admin-kjson.html';
import './oo-admin-kjson.scss';

export default {
	bindings: {
		kjson:    '<ngModel',
		class:    '@?',
		icon:     '@?',
		label:    '@?',
		form:     '<?',
		onChange: '&?',
		disabled: '<?ngDisabled',
	},
	controller,
	template,
	controllerAs: '$ctrl',
	require: {
		ngModelCtrl: '?ngModel',
	},
};
